
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/galleries/[id]/collections/[collection]",
      function () {
        return require("private-next-pages/galleries/[id]/collections/[collection].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/galleries/[id]/collections/[collection]"])
      });
    }
  